import React, { useEffect } from 'react';
import Storage from '../helpers/Storage';
import { USER_KEY } from '../modules/Users/Store';
import history from '../helpers/History';
import { inject } from 'mobx-react';
import queryString from 'query-string';
import { Loading } from '../elements';
var CheckUserMark = function (props) {
    useEffect(function () {
        /*const user = JSON.parse(Storage.get(USER_KEY))
        if (user && user.token && user.client && user.tradename) {
          props.store.users.getUser().then(result => history.push('/calendar'))
            .catch(error => history.push('/login'))
        } else {*/
        var query = queryString.parse(window.location.search);
        if (query['userToken'] && query['clientName'] && query['tradename']) {
            console.log('guardando datos usuario');
            Storage.set(USER_KEY, JSON.stringify({
                token: query['userToken'],
                client: query['clientName'],
                tradename: query['tradename'],
            }));
            console.log('esperando datos ...');
            props.store.users.getUser().then(function (result) {
                console.log('result: ', result);
                return history.push('/calendar');
            });
            // .catch(error => history.push('/login'))
            // }
        }
    }, []);
    return (React.createElement(Loading, null));
};
export default inject('store')(CheckUserMark);



//////////////////
// WEBPACK FOOTER
// ./src/components/CheckUserMark.tsx
// module id = 1616
// module chunks = 0